export const SYMBOLS = {
  NuxtAxiosInstance: Symbol('NuxtAxiosInstance'),
  PuFetchInstance: Symbol('PuFetchInstance'),
  SentryInstance: Symbol('sentry'),
  SentryReadyInstance: Symbol('$sentryReady'),
}
